<template>
    <section id="page7">
        <div class="container container-top">
            <div class="col-left">
                <div>
                    <lottie-player :src="`animas/0/page08.json`" v-if="persona==0" ref="lottiepage8" id="page8anima0" class="anima"
                        loop="false"
                        transparent
                        >
                    </lottie-player>
                    <lottie-player :src="`animas/1/page08.json`" v-if="persona==1" ref="lottiepage8" id="page8anima1" class="anima"
                        loop="false"
                        transparent
                        >
                    </lottie-player>
                    
                </div>
            </div>
            <div class="col-right" >
                <h2>
                    Como trabalhamos
                </h2>
                <p>
                    Aqui, usamos os anos de experiência dos nossos colaboradores e boas práticas do mercado para definir nossa metodologia de trabalho exclusiva.
                </p>
            </div>
        </div>
        <div class="container container-bottom" data-aos="fade" data-aos-delay="600">
            <div class="swipercards">
                <swiper ref="mySwiper" :options="swiperOptions" @slideChange="runOnChange">
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="fade"  data-aos-delay="300">
                                <img src="@/assets/img/page7-img2.png" alt="" @load="loadImage">
                                <h2>Gamificação</h2>
                                <p class="tagline">
                                    A VIAGEM FICA MELHOR SE ELA É EMOCIONANTE!
                                </p>
                                <p>
                                    Temos orgulho e confiança em dizer que gamificação é o nosso superpoder e nosso diferencial. 
                                    Está em nossa essência! Para aplicar técnicas de gamificação na educação corporativa, nos mantemos sempre atualizados: 
                                    frameworks, técnicas novas e referências mil são as nossas ferramentas principais.
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card"  data-aos="fade"  data-aos-delay="300">
                                <img src="@/assets/img/page7-img3.png" alt="" @load="loadImage">
                                <h2>Taxonomia de Bloom</h2>
                                <p class="tagline">
                                    TODA VIAGEM PRECISA DE UM BOM GPS! 
                                </p>
                                <p>
                                    Para a nossa equipe, a Taxonomia de Bloom é um guia poderoso que define desde o começo do projeto o objetivo de 
                                    aprendizado em que estamos trabalhando. Por isso, não são só os Designers Instrucionais que dominam o assunto, não! 
                                    Esse time treina Programadores, Designers Gráficos, Gerentes de Projeto e de área para que todos conheçam a metodologia, 
                                    afinal, as definições do treinamento - do formato da peça, tipos de questões a serem usadas e caminhos a serem seguidos - são 
                                    feitas com base nesse objetivo principal.
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card"  data-aos="fade"  data-aos-delay="300">
                                <img src="@/assets/img/page7-img4.png" alt="" @load="loadImage">
                                <h2>Mapa de Projeto</h2>
                                <p class="tagline">
                                    NOSSA NAVE É CARREGADA DE EXPERIÊNCIA!
                                </p>
                                <p>
                                    A junção do conhecimento de muitos Designers Instrucionais e anos de atuação resultaram em uma metodologia própria. 
                                    O Mapa de Projeto Games e E-learning é um documento usado para investigar, coletar e registrar informações sobre o público-alvo, 
                                    as necessidades de negócio, as expectativas dos stakeholders, as especificidades técnicas e os direcionamentos visuais.
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card"  data-aos="fade"  data-aos-delay="300">
                                <img src="@/assets/img/page7-img5.png" alt="" @load="loadImage">
                                <h2>Storytelling</h2>
                                <p class="tagline">
                                    PORQUE EXISTEM FORMAS DE FAZER A VIAGEM SER AINDA MAIS INESQUECÍVEL!
                                </p>
                                <p>
                                    Aqui na LG lugar de gente levamos muito a sério a experiência que as pessoas têm ao fazer nossos treinamentos. 
                                    Por isso, usamos ferramentas para potencializar o momento de aprendizagem. 
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card"  data-aos="fade"  data-aos-delay="300">
                                <img src="@/assets/img/page7-img6.png" alt="" @load="loadImage">
                                <h2>Escuta</h2>
                                <p class="tagline">
                                    O CAPITÃO DA NOSSA NAVE É SEMPRE VOCÊ.
                                </p>
                                <p>
                                    Sabemos e damos muita importância para o que você diz, afinal, quem melhor conhece a sua tripulação e as necessidades do negócio é você! 
                                    Por isso, ouvido afiado é uma metodologia que nem sempre se encontra no mercado, mas que temos aqui! 
                                    Juntos, iremos construir a viagem de aprendizagem mais incrível e significativa para os colaboradores.
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <!-- <div class="swiper-button-prev swiper-button-prev1" slot="button-prev"></div>
                    <div class="swiper-button-next swiper-button-next1" slot="button-next"></div> -->
                </swiper>
                <div class="bullets">
                    <div class="swiper-pagination swiper-pagination3" slot="pagination"></div>
                </div>
            </div>
        </div>
        <div class="container container-buttom">
            <div class="col-unique">
                <p>
                    Solicite contato para conhecer saber como as soluções podem decolar a aprendizagem corporativa da sua empresa. 
                </p>
                <button class="btn-gradient" @click="goPage('#formcard')">Solicitar contato</button>
            </div>
        </div>
    </section>
</template>
<script>
import { create } from '@lottiefiles/lottie-interactivity';
export default {
    props: ['persona'],
    data() {
        return {
            totalImages: 5,
            countImages: 0,
            swiperOptions: {
                slidesPerView: 1,
                centeredSlides: false,
                pagination: {
                    el: '.swiper-pagination3',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next1',
                    prevEl: '.swiper-button-prev1'
                },
                breakpoints: {
                    1140: {
                        slidesPerView: 2,
                    },
                    900: {
                        slidesPerView: 1,
                    }
                }
            }
        }
    },
    computed: {
        swiper() {
        return this.$refs.mySwiper.swiper
        }
    },
    methods: {
        loadImage() {
            this.countImages++;
            if(this.countImages == this.totalImages) {
                this.$emit("refreshAos");
            }
        },
        runOnChange(evt) {
            if(this.$refs.mySwiper.$swiper.activeIndex==(this.$refs.mySwiper.$children.length-1)){
                // console.log("FINALIZOU");
            }
        },
        goPage(value) {
            this.menuStatus = false;
            // this.$scrollTo(value);
            this.$emit("unlockAll")
            this.sleep().then(() => {
                this.$nextTick(() => {
                    this.$scrollTo(value, {
                        offset: 0
                    });
                });
            })
        },
        sleep: function (ms = 100) {
            return new Promise(resolve => setTimeout(resolve, ms))
        }
    },
    mounted() {
        if(this.persona == 0) {
            this.$refs.lottiepage8.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page8anima0',
                        actions: [
                            {
                                visibility: [0, .2],
                                type: "play"
                            }
                        ],
                });
            })
        } else {
            this.$refs.lottiepage8.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page8anima1',
                        actions: [
                            {
                                visibility: [0, .2],
                                type: "play"
                            }
                        ],
                });
            })
        }
    }
}
</script>
<style lang="scss" scoped>
section {
    background-color: $color-secondary;
    color: $color-text-light;
    background-image: url("~@/assets/img/page7-bg.svg");
    background-repeat: no-repeat;
    background-size: auto;
    background-attachment: fixed;
    background-position: center top;
    .container {
        padding-top: 56px;
        padding-bottom: 56px;
        // justify-content: flex-start;
        align-items: center;
        .swipercards {
            display: block;
            width: 100%;
            article {
                width: 100%;
                max-width: 485px;
                margin-left: 10px;
                margin-right: 10px;
                border-radius: 28px;
                box-shadow: 0px 10px 16px 0px rgba(0,0,0,0.16);
                border: 1px solid #B2B2B2;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                // overflow: hidden;
                background-color: white;
                color: $color-text-dark;
                text-align: left;
                // width: 902px;
                // height: 253px;
                min-height: 790px;
                padding-left: 15px;
                padding-right: 15px;
                padding-top: 15px;
                padding-bottom: 15px;
                img {
                    max-width: 100%;
                }
                h2 {
                    padding-top: 30px;
                    padding-bottom: 20px;
                }
                .tagline {
                    color: $color-secondary;
                    font-weight: bold;
                    padding-bottom: 30px;
                }
                ul {
                    list-style-position: inside;
                    line-height: 1.7rem;
                    padding-bottom: 10px;
                }
                .box {
                    background-color: rgba(0, 0, 0, .1);
                    border-radius: 20px;
                    padding: 20px;
                }
            }
            .bullets {
                height: 100px;
                display: flex;
                justify-content: center;
            }
        }
        .col-left {
            align-self: stretch;
            display: flex;
            flex: 1 1 0%;
            flex-direction: column;
            margin-bottom: 30px;
            .persona {
                max-width: 100%;
                padding-bottom: 46px;
                padding-top: 30px;
            }
            
            .anima {
                max-height: 450px;
                padding-bottom: 45px;
                max-width: 469px;
                margin: 0 auto;
            }
        }
        .col-right {
            h2 {
                padding-bottom: 30px;
            }
            flex-basis: 50%;
        }
    }
    .container-buttom {
        padding-top: 0;
        p {
            padding-bottom: 30px;
        }
        padding-bottom: 90px;
    }
    @media only screen and (max-height: 780px) {
        .sticky {
            padding-top: 0;
            position: relative;
            // position: -webkit-sticky;
            overflow: auto;
            top: 0;
        }
    }
    @media only screen and (max-width: 1140px) {
        .container {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .col-left {
                flex-basis: 100%;
                padding-bottom: 30px;
                text-align: center;
            }
            .col-right {
                flex-basis: 100%;
            }
        }
    }
    @media only screen and (max-width: 600px) {
        .container {
            
            .col-right {
                display: none;
                flex-direction: column;
                .cards-right {
                    margin-top: 0;
                    margin-bottom: 0;
                }
                .card {
                    img {
                        height: auto;
                    }
                }
            }
        }
    }
}
</style>